module.exports = __webpack_public_path__ + "img/honor-right-1-1.abe87cbb.jpg";